import DataMapper from './DataMapper'
import Holiday from '../../models/Holiday'
import HolidayRM from '../responsemodel/HolidayRM'

export default class HolidayDataMapper extends DataMapper<HolidayRM, Holiday> {
  map = (rm: HolidayRM) => {
    return new Holiday(rm.date, rm.title)
  }
}
